// src/pages/EmailValidado.tsx

import React, { useEffect } from 'react'
import { Button } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'

const EmailValidado = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login')
    }, 10000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        fontFamily: 'Montserrat',
        padding: 20,
        textAlign: 'center'
      }}
    >
      <h1 style={{ color: '#1A3661' }}>
        E-mail validado com sucesso!
      </h1>

      <p>
        Seu acesso foi liberado.
      </p>

      <p>
        Você será redirecionado para o login em 10 segundos.
      </p>

      <Button
        variant="contained"
        style={{
          backgroundColor: '#1A3661',
          color: '#fff',
          marginTop: 20
        }}
        onClick={() => navigate('/login')}
      >
        Ir para login
      </Button>
    </div>
  )
}

export default EmailValidado